import React from 'react';
import { motion } from 'framer-motion';
import { LayoutTemplate, Zap, BookOpen } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide8Portfolio({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-276">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-277">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-278">
          Campaign Portfolio Recommendation
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-279">
          A clear recommendation with{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-280">
            three connected parts.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-6 min-h-0" data-id="element-281">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="col-span-12 h-32 rounded-2xl overflow-hidden relative mb-2 shadow-sm" data-id="element-282">
          <img src="https://cdn.magicpatterns.com/uploads/2evvkdLNjqRnzgEzp1i1EW/Screenshot_2026-06-29_at_09.44.40.png" alt="Anzupgo Tubes" className="w-full h-full object-cover object-center" data-id="element-283" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent flex items-center p-8" data-id="element-284">
            <h3 className="text-white font-bold text-2xl" data-id="element-285">
              Building the Engagement Engine
            </h3>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="col-span-4 bg-[var(--surface)] rounded-2xl p-6 border border-black/5 flex flex-col" data-id="element-286">
          <div className="flex items-center gap-3 mb-4" data-id="element-287">
            <div className="w-10 h-10 rounded-full bg-[var(--brand-green)]/10 flex items-center justify-center" data-id="element-288">
              <LayoutTemplate className="w-5 h-5 text-[var(--brand-green)]" data-id="element-289" />
            </div>
            <h3 className="text-xl font-bold text-[var(--fg)]" data-id="element-290">
              Part 1: Snakkify Website
            </h3>
          </div>
          <p className="text-[var(--brand-green)] font-bold mb-4" data-id="element-291">
            Est. €15,000
          </p>
          <p className="text-[var(--muted)] text-sm font-medium mb-4" data-id="element-292">
            Create easy-to-digest Snak modules based on core DermaWorld Anzupgo
            pages content.
          </p>
          <ul className="space-y-2 text-sm font-medium text-[var(--fg)] flex-1 overflow-y-auto" data-id="element-293">
            <li data-id="element-294">• CHE burden / unmet need</li>
            <li data-id="element-295">• Patient identification</li>
            <li data-id="element-296">• Targeted treatment differentiation</li>
            <li data-id="element-297">• Efficacy confidence</li>
            <li data-id="element-298">• Safety reassurance</li>
            <li data-id="element-299">• Practical use / application</li>
            <li data-id="element-300">• Long-term confidence</li>
          </ul>
          <div className="mt-4 bg-[var(--brand-green)]/[0.06] border border-[var(--brand-green)]/15 rounded-xl p-4" data-id="element-301">
            <p className="text-[var(--brand-green)] text-xs font-bold uppercase tracking-wider mb-1" data-id="element-302">
              The foundation for everything
            </p>
            <p className="text-[var(--fg)] text-sm font-medium leading-relaxed" data-id="element-303">
              Beyond the website, Part 1 establishes the content repository,
              strategic messaging and campaign building blocks — the shared
              foundation that Parts 2 &amp; 3 are built on.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.5
      }} className="col-span-4 bg-[var(--surface)] rounded-2xl p-6 border border-black/5 flex flex-col" data-id="element-304">
          <div className="flex items-center gap-3 mb-4" data-id="element-305">
            <div className="w-10 h-10 rounded-full bg-[var(--brand-green)]/10 flex items-center justify-center" data-id="element-306">
              <Zap className="w-5 h-5 text-[var(--brand-green)]" data-id="element-307" />
            </div>
            <h3 className="text-xl font-bold text-[var(--fg)]" data-id="element-308">
              Part 2: Teaser Masters*
            </h3>
          </div>
          <p className="text-[var(--brand-green)] font-bold mb-4" data-id="element-309">
            Est. €2,500–€3,000 each
          </p>
          <p className="text-[var(--muted)] text-sm font-medium mb-2" data-id="element-310">
            Short, provocative, problem-led hooks to qualify interest before the
            click.
          </p>
          <p className="text-[var(--brand-green)] text-xs font-semibold mb-4 italic" data-id="element-311">
            * Each teaser is created as a ready-to-execute campaign and includes
            an animated hook for post, banner, email, etc.
          </p>
          <ul className="space-y-3 text-sm font-medium text-[var(--fg)] flex-1 overflow-y-auto" data-id="element-312">
            <li data-id="element-313">
              <span className="font-bold" data-id="element-314">T1:</span> “When topical
              corticosteroids are not enough”
            </li>
            <li data-id="element-315">
              <span className="font-bold" data-id="element-316">T2:</span> “Not all CHE patients are
              the same”
            </li>
            <li data-id="element-317">
              <span className="font-bold" data-id="element-318">T3:</span> “Which CHE patient would
              you consider first?”
            </li>
            <li data-id="element-319">
              <span className="font-bold" data-id="element-320">T4:</span> “What is your main
              hesitation?”
            </li>
            <li data-id="element-321">
              <span className="font-bold" data-id="element-322">T5:</span> “Are you seeing the full
              burden of CHE?”
            </li>
            <li data-id="element-323">
              <span className="font-bold" data-id="element-324">T6:</span> “How confident are you in
              your next step?”
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="col-span-4 bg-[var(--surface)] rounded-2xl p-6 border border-black/5 flex flex-col" data-id="element-325">
          <div className="flex items-center gap-3 mb-4" data-id="element-326">
            <div className="w-10 h-10 rounded-full bg-[var(--brand-green)]/10 flex items-center justify-center" data-id="element-327">
              <BookOpen className="w-5 h-5 text-[var(--brand-green)]" data-id="element-328" />
            </div>
            <h3 className="text-xl font-bold text-[var(--fg)]" data-id="element-329">
              Part 3: Trailer Masters
            </h3>
          </div>
          <p className="text-[var(--brand-green)] font-bold mb-4" data-id="element-330">
            Est. €4,500 each
          </p>
          <p className="text-[var(--muted)] text-sm font-medium mb-4" data-id="element-331">
            Longer, deeper Snak experiences acting as rich modules and
            microsites.
          </p>
          <ul className="space-y-4 text-sm font-medium text-[var(--fg)] flex-1 overflow-y-auto" data-id="element-332">
            <li data-id="element-333">
              <span className="font-bold block" data-id="element-334">
                Trailer 1: Differentiation
              </span>
              <span className="text-[var(--muted)]" data-id="element-335">
                “Why targeted topical treatment matters in CHE”
              </span>
            </li>
            <li data-id="element-336">
              <span className="font-bold block" data-id="element-337">
                Trailer 2: Trialist confidence
              </span>
              <span className="text-[var(--muted)]" data-id="element-338">
                “First appropriate use of Anzupgo”
              </span>
            </li>
            <li data-id="element-339">
              <span className="font-bold block" data-id="element-340">
                Trailer 3: Frequent prescriber
              </span>
              <span className="text-[var(--muted)]" data-id="element-341">
                “Building confidence beyond the first patient”
              </span>
            </li>
          </ul>
        </motion.div>
      </div>
    </div>;
}